module.exports = __webpack_public_path__ + "img/gybc@2x.9174e02c.png";